import {
  CLEAR_CREATE_TRANSACTION,
  SET_BIDS_TEXT_VALUE,
  SET_TRANSACTION_BID_DROPDOWN_VALUE,
  SET_VIEW_TRANSACTION_BIDS,
} from "../action";
import { bids } from "./initial-store";

const initialState = bids;

function transactionBidsReducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_TRANSACTION_BID_DROPDOWN_VALUE: // for dealResult and resultReason
      newState = {
        ...state,
        [action.payload.domainName]: action.payload.domainValue,
      };
      return newState;

    case SET_BIDS_TEXT_VALUE:
      newState = {
        ...state,
        [action.payload.textKey]: action.payload.textValue,
      };
      return newState;

    case CLEAR_CREATE_TRANSACTION:
      newState = initialState;
      return newState;
    case SET_VIEW_TRANSACTION_BIDS:
      let bidsData = {
        dealResult: action.payload.dealResult,
        currency: action.payload.currency,
        machineOrigMDP: action.payload.machOrigMdp,
        extAttachCost: action.payload.partsAttCost,
        extAttachDesc: action.payload.partsAttDesc,
        rentalIncome: action.payload.rentalApplied,
        totDiscountApplied: action.payload.deereDiscApplied,
        addnlDlrCost: action.payload.addnDlrCost,
        finBuyDownCost: action.payload.finBuydownCost,
        freightPDICost: action.payload.frtPdiCost,
        dlrMarginPct: action.payload.dlrMargin,
      };
      newState = { ...bidsData };
      return newState;

    default:
      return state;
  }
}

export default transactionBidsReducer;
